
define('template!adminColorSelectionsListRowToolsView', ['lodash'], function(_) {return function(obj) {
obj || (obj = {});
var __t, __p = '', __e = _.escape;
with (obj) {
__p += '<button type="button" class="btn btn-link btn-edit" title="' +
((__t = ( _.escape(editLabel) )) == null ? '' : __t) +
'"><i class="fa fa-pencil"></i></button>\n<button type="button" class="btn btn-link btn-delete" title="' +
((__t = ( _.escape(deleteLabel) )) == null ? '' : __t) +
'"><i class="fa fa-trash"></i></button>\n';

}
return __p
};});

